<template>
<div>
    <vue-recaptcha v-if="!(isRecaptchaVerified || isAuthenticated)"
    @verify="onCaptchaVerify"
    @error="onCaptchaError"
    :sitekey="reCaptchaSiteKey"
    :load-recaptcha-script="true"
    size="normal">
    </vue-recaptcha>
    <slot v-else></slot>
</div>
</template>

<script>
import appConfig from "@/app.config";
import { VueRecaptcha } from 'vue-recaptcha';

import store from '@/store';
import { authStore } from '@/modules/auth/store';

export default {
  name: 'ReCaptcha',
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      reCaptchaSiteKey: '',
    };
  },
  created() {
    this.reCaptchaSiteKey = appConfig.googleReCaptchaSiteKey;
  },
  computed: {
    isRecaptchaVerified() {
      return store.getters.isRecaptchaVerified;
    },
    isAuthenticated() {
      return !!authStore.state.loggedUser && Object.keys(authStore.state.loggedUser).length > 0;
    },
  },
  methods: {
    onCaptchaVerify(response) {
      if(response) {
        setTimeout(function(){
          store.commit('setRecaptchaVerifiedFlag', true);
        }, 500)
      }
    },
    onCaptchaError(err) {
      console.log('recaptcha error', err);
    },
  }
}
</script>